<div class="page" id="page_arena">
    <div class="container">

        <h2 class="section-title">NOSSO ESPAÇO</h2>
        <p>Tudo o que você precisa para treinar com conforto.</p>

        <div class="section-divider"></div>

        <div class="window">
            <div class="tabs estrutura">
                <div class="list">
                    <h4>Estrutura</h4>
                    <ul>
                        <li><span><fa-icon [icon]="faCheck" />2 áreas de treino</span></li>
                        <li><span><fa-icon [icon]="faCheck" />Red Fight Zone</span></li>
                        <li><span><fa-icon [icon]="faCheck" />Vestiários completos</span></li>
                        <li><span><fa-icon [icon]="faCheck" />Vagas de estacionamento em frente</span></li>
                    </ul>
                </div>
            </div>
            <div class="tabs comodidades" style="opacity: 1;">
                <div class="list">
                    <h4>Comodidades</h4>
                    <ul>
                        <li><fa-icon [icon]="faIcon2" /><span>Luvas para treino</span></li>
                        <li><fa-icon [icon]="faIcon2" /><span>Água (com e sem gás)</span></li>
                        <li><fa-icon [icon]="faIcon2" /><span>Café</span></li>
                        <li><fa-icon [icon]="faIcon2" /><span>Toalhas de banho</span></li>
                        <li><fa-icon [icon]="faIcon2" /><span>Secador de cabelo</span></li>
                        <li><fa-icon [icon]="faIcon2" /><span>Shampoo e condicionador</span></li>
                        <li><fa-icon [icon]="faIcon2" /><span>Elástico de cabelo</span></li>
                        <li><fa-icon [icon]="faIcon2" /><span>Produtos de proteção diária</span></li>
                        <li><fa-icon [icon]="faIcon2" /><span>Demaquilante e algodão</span></li>
                        <li><fa-icon [icon]="faIcon2" /><span>Desodorante</span></li>
                    </ul>
                </div>
            </div>
            <div id="gallery" class="list">
                <div>
                    <h4>Galeria</h4>
                    
                    <ul class="gallery">
                        <li>
                            <a (click)="navigate('modal-img-1')"><img src="assets/arena/arena001.jpeg" alt="Área de treino da New Fight" loading="lazy" decoding="async" /></a>
                        </li>
                        <li>
                            <a (click)="navigate('modal-img-2')"><img src="assets/arena/arena002.jpeg" alt="Área de treino da New Fight" loading="lazy" decoding="async" /></a>
                        </li>
                        <li>
                            <a (click)="navigate('modal-img-3')"><img src="assets/arena/arena003.jpeg" alt="Área de treino da New Fight" loading="lazy" decoding="async" /></a>
                        </li>
                        <li>
                            <a (click)="navigate('modal-img-4')"><img src="assets/arena/arena004.jpeg" alt="Área de treino da New Fight" loading="lazy" decoding="async" /></a>
                        </li>
                        <li>
                            <a (click)="navigate('modal-img-5')"><img src="assets/arena/arena005.jpeg" alt="Área de treino da New Fight" loading="lazy" decoding="async" /></a>
                        </li>
                    </ul>
                </div>
            </div>
            
        </div>

        <div class="section-divider"></div>

        <div class="page-footer">
            <h4>AGENDE UMA AULA EXPERIMENTAL</h4>
            
            <a class="btn primary-line" 
                target="_blank"  
                href="https://api.whatsapp.com/send?phone=+5511976626886&text=Olá, gostaria de obter informações sobre a New Fit Performance Club"
                (click)="navigate('joinus')">
                <span>AGENDAMENTOS </span>
                <fa-icon [icon]="faWhatsapp" />
            </a>
        </div>

        <div class="section-divider"></div>

        <br/><br/>

    </div>
</div>
